import { StyledPageError } from "./PageErrorNotDesktop.styled";
import imageNotDesktop from "../../../images/error_not_desktop.svg";
import { BodyTyp, TitlesTyp } from "../../../components/Typography/Typography";
import { FontWeightEnum } from "../../../types/AppTypes";
import { theme } from "../../../constants/StyledComponents";
import {
  ERROR_NOT_SUPPORTED_SCREEN_LABEL,
  ERROR_NOT_SUPPORTED_SCREEN_MESSAGE_LABEL,
} from "../../../constants/Dictionary";

const PageErrorNotDesktop = () => {
  return (
    <StyledPageError>
      <div className="error-not-desktop-container">
        <div className="error-not-desktop-header">
          <img src={imageNotDesktop} width={350} />
        </div>
        <div className="error-not-desktop-content">
          <TitlesTyp
            variant="1"
            fontWeight={FontWeightEnum.SEMIBOLD}
            color={theme.colors.black}
          >
            {ERROR_NOT_SUPPORTED_SCREEN_LABEL}
          </TitlesTyp>
          <BodyTyp
            variant="1"
            fontWeight={FontWeightEnum.REGULAR}
            color={theme.colors.black}
          >
            {ERROR_NOT_SUPPORTED_SCREEN_MESSAGE_LABEL}
          </BodyTyp>
        </div>
      </div>
    </StyledPageError>
  );
};

export default PageErrorNotDesktop;
